export { OAuthService } from "./OAuthService";
export { withAccessToken, getAccessToken } from "./withAccessToken";

export type { WithAccessTokenComponentOrFn } from "./withAccessToken";
export type {
  OnAuthorizeParams,
  OAuthServiceOptions,
  ProviderWithDefaultClientOptions,
  ProviderOptions,
} from "./types";
